module.exports = __webpack_public_path__ + "static/media/boss-clear.28b4a923.mp3";